import { useContext } from 'react';
import AbilityContext from 'src/contexts/AbilityContext';

const useAbility = () => {
  return useContext(AbilityContext);
};

export default useAbility;
